import React from 'react';
import { Text } from '@chakra-ui/react';
import styles from './styles.module.css';
import TruncatedText from './truncated-text';

export const TextRegular = (props) => (
  <Text {...props} className={`${props.className} ${styles['text__reguler']}`}>
    {props?.children}
  </Text>
);
export const TextMedium = (props) => (
  <Text {...props} className={`${props.className} ${styles['text__medium']}`}>
    {props?.children}
  </Text>
);
export const TextSemiBold = (props) => (
  <Text {...props} className={`${props.className} ${styles['text__semibold']}`}>
    {props?.children}
  </Text>
);
export const TextBold = (props) => (
  <Text {...props} className={`${props.className} ${styles['text__bold']}`}>
    {props?.children}
  </Text>
);
export const TextExtraBold = (props) => (
  <Text {...props} className={`${props.className} ${styles['text__extrabold']}`}>
    {props?.children}
  </Text>
);

export const TextWithHighlight = ({ styleHighlight, text, textHighlight, ...props }) => {
  const formatTextWithHighlight = (text, textHighlight) => {
    // Check if the text contains the highlight text
    if (!text) return null;
    if (!textHighlight) return text;
    if (!text.includes(textHighlight)) return text;

    // Split the text by the highlight text
    const parts = text.split(textHighlight);
    return parts.map((part, index) => {
      if (index === parts.length - 1) return part;
      return (
        <React.Fragment key={`text-part-${index}`}>
          {part}
          <span key={`highlight-${index}`} style={styleHighlight}>
            {textHighlight}
          </span>
        </React.Fragment>
      );
    });
  };

  return (
    <Text {...props} className={`${props.className} ${styles['text__reguler']}`}>
      {formatTextWithHighlight(text, textHighlight)}
    </Text>
  );
};

export const TextInActive = (props) => (
  <Text {...props} className={`${props.className} ${styles['text__inactive']}`}>
    {props?.children}
  </Text>
);

export const TextDisabled = (props) => (
  <Text {...props} className={`${props.className} ${styles['text__disabled']}`}>
    {props?.children}
  </Text>
);

export const TextBlank = (props) => {
  const { children, as, ...restProps } = props;
  const isBlank = children === '-' || children === '' || children === null || children === undefined;

  if (as) {
    const Component = as;
    return (
      <Component {...restProps} className={`${props.className} ${isBlank ? styles['text__blank'] : ''}`}>
        {isBlank ? 'Blank' : children}
      </Component>
    );
  }

  return (
    <Text {...restProps} className={`${props.className} ${isBlank ? styles['text__blank'] : ''}`}>
      {isBlank ? 'Blank' : children}
    </Text>
  );
};

export { TruncatedText };
